const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the content integration config
 * @argument {Application} Application injected to gain access to the global Application service
 * @argument {AccessProfiles} AccessProfiles injected to gain access to the AccessProfiles resource
 */
app.directive('accessProfileManager', ['Application', 'Authorization', 'AccessProfiles', function (Application, Authorization, AccessProfiles) {
  return {
    restrict: "E",
    replace: true,
    scope : {},
    template: require('../../../templates/directives/access_profile/access-profile-manager.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.user = Authorization.getAuthToken().user;
      self.profiles = [];

      self.createProfile = function() {
        Application.navigation.goTo('/edit/access-profiles');
      };

      self.selectedForDelete;
      self.selectDelete = function(item) {
        self.selectedForDelete = item;
        self.showDelete = true;
      };

      self.deleteSelected = function() {
        self.loading = true;

        AccessProfiles.delete({subresource: self.selectedForDelete}).$promise
        .then(function(results) {
          self.editMenu.closeHandler();
          self.loading = false;
          self.showDelete = false;
          self.paging.page = 1;
          self.paging.userCount = {};
          self.paging.map = {};
          self.paging.confirmedLast = null;
          self.getPage();
          Application.messaging.addMessage({type: 'success', text: 'Profile Removed.', duration: 5});
        }).catch(function(error) {
          self.loading = false;
          Application.messaging.addMessage({type: 'error', text: 'There was an issue removing the profile.', duration: 7});
        });
      };

      self.assign = {
        selection: {},
        show: false,
        success: false,
        select: function(item) {
          self.assign.selection = item;
          self.assign.show = true;
        },
        edit: function(item) {
          Application.navigation.goTo('/edit/access-profile/' + item._id);
        },
        cancel: function() {
          self.assign.show = false;
          self.assign.selection = {};
          self.editMenu.closeHandler();
        },
        onComplete: function() {
          var selectedId = self.assign.selection._id;
          self.paging.getUserCounts(selectedId);
          self.assign.cancel();
        }
      };

      self.editMenu = {
        visible: false,
        activeId: null,
        closeHandler: function(){
          self.editMenu.visible = false;
          self.editMenu.activeId = null;
        },
        clickHandler: function(i){
          if (self.editMenu.visible) {
            if (self.editMenu.activeId === i) {
              self.editMenu.visible = false;
              self.editMenu.activeId = null;
            } else {
              self.editMenu.activeId = i;
            }
          } else {
            self.editMenu.activeId = i;
            self.editMenu.visible = true;
          }
        }
      };

      self.paging = {
        page: 1,
        perPage: 10,
        search_term: '',
        delayed_load: null,
        userCount: {},
        map: {},
        confirmedLast: null,
        showUsers: false,
        selectedUsers: null,
        selectForUsers: function(profile) {
          self.paging.selectedUsers = profile;
          self.paging.showUsers = true;
        },
        next: function() {
          if (self.paging.confirmedLast && self.paging.page >= self.paging.confirmedLast) {
            return;
          }

          self.paging.page++;
          self.getPage();
        },
        previous: function() {
          if (self.paging.page <= 1) {
            return;
          }

          self.paging.page--;
          self.getPage();
        },
        getUserCounts: function(id) {
          var profiles = id ? [id] : self.profiles.map(function(item) {
            return item._id;
          });

          AccessProfiles.userCount({profiles: profiles.join(',')}).$promise
          .then(function(results) {
            for (var key in results) {
              self.paging.userCount[key] = results[key];
            }
          });
        }
      };

      $scope.$watch('access.paging.search_term', function(newVal, oldVal) {
        if (newVal !== oldVal) {
          if (self.paging.delayed_load) {
            clearTimeout(self.paging.delayed_load);
          }

          self.paging.delayed_load = setTimeout(function() {
            self.paging.page = 1;
            self.getPage();
            self.paging.delayed_load = null;
          }, 500);
        }
      });

      self.getPage = function() {
        if (!self.paging.search_term && self.paging.map[self.paging.page]) {
          self.profiles = self.paging.map[self.paging.page];
          return;
        }

        self.loading = true;

        var query = {
          fields: 'name,description,created_by,createdAt',
          'created_by-populate': 'first_name,last_name,full_name,email',
          page: self.paging.page,
          per_page: self.paging.perPage
        };

        if (self.paging.search_term) {
          query['$or'] = '10,name,$regex,2,' + self.paging.search_term + ',i,tags,$regex,2,' + self.paging.search_term + ',i';
        }

        AccessProfiles.find(query).$promise
        .then(function(profiles) {
          if (!profiles || !profiles.length) {
            if (!self.paging.search_term) {
              self.paging.confirmedLast = self.paging.page - 1;
            }
            self.paging.page--;
            self.loading = false;
            return;
          }

          if (!self.paging.search_term &&profiles.length < self.paging.perPage) {
            self.paging.confirmedLast = self.paging.page;
          }

          if (!self.paging.search_term) {
            self.paging.map[self.paging.page] = profiles;
          }

          self.profiles = profiles || [];
          self.paging.getUserCounts();
          self.loading = false;
        }).catch(function(err) {
          console.log(err);
          Application.messaging.addMessage({type: 'error', text: 'Error in getting access profiles.', duration: 5});

          self.loading = false;
        });
      };

      self.initialize = function() {
        if (!self.user || !self.user.role || self.user.role !== 'admin') {
          Application.navigation.back();
          return;
        }

        self.getPage();
      };

      self.initialize();

    }],
    controllerAs: 'access'
  };
}]);